// extracted by mini-css-extract-plugin
module.exports = {"subMenuLabel":"headerAdmin_subMenuLabel__3yQR0","subMenu":"headerAdmin_subMenu__d6I70","show":"headerAdmin_show__yfKux","icon":"headerAdmin_icon__2rwFx"};